import React, { ReactNode } from 'react';
import { FeatureJobsBrowserStore } from './jobs-browser.store';

const JobsBrowserContext = React.createContext<FeatureJobsBrowserStore | null>(null);

export const JobsBrowserProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<FeatureJobsBrowserStore>(() => new FeatureJobsBrowserStore());

   return <JobsBrowserContext.Provider value={store}>{children}</JobsBrowserContext.Provider>;
};

export const useJobsBrowser = () => {
   const ctx = React.useContext(JobsBrowserContext);

   if (!ctx) {
      throw new Error('useJobsBrowser must be used inside JobsBrowserProvider');
   }

   return ctx;
};
